import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyBkKflaMTaD0qw8V3dc9ZThwC3V9192GzE',
  authDomain: 'metamax-390e2.firebaseapp.com',
  projectId: 'metamax-390e2',
  storageBucket: 'metamax-390e2.firebasestorage.app',
  messagingSenderId: '933576909348',
  appId: '1:933576909348:web:59679483c7568de9636eb1',
  measurementId: 'G-NSC64WWKE1',
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export default app;
